import React from 'react';
import { FuelTypography, FuelSign } from '@frete.com/fuel-react';
import * as Styled from './UpdateYourPlanStyles';
import { UpdateYourPlanProps } from './UpdateYourPlanType';

function UpdateYourPlan({ title, children }: UpdateYourPlanProps) {
  return (
    <Styled.Wrapper>
      <FuelSign icon="key-shining" size="medium" color="orange" />
      <Styled.WrapperTitle>
        <FuelTypography
          tag="h3"
          size="heading-lg"
          weight="bold"
          color="neutral-strong"
          spacingTop={16}
        >
          {title}
        </FuelTypography>
      </Styled.WrapperTitle>
      <Styled.WrapperContent>{children}</Styled.WrapperContent>
    </Styled.Wrapper>
  );
}

export default UpdateYourPlan;
